module.exports = __webpack_public_path__ + "img/bg_img03.423c5e09.png";